/**
 * Created by woo on 01/06/2017.
 */

import React, { Component } from 'react'
import { Route } from 'react-router-dom'

import Portal from './containers/Portal'
import WechatAuth from './containers/WechatAuth'
import Binding from './containers/Binding'
import Home from './containers/Home'
import NotFound from './containers/NotFound'

class App extends Component {
  render() {
    return (
      <div style={{ height: '100vh' }}>
        <Route exact path="/" component={Portal} />
        <Route exact path="/wechat" component={WechatAuth} />
        <Route exact path="/binding" component={Binding} />
        <Route path="/home" component={Home} />
        <Route path="/NotFound" component={NotFound} />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/routes.js